import { apiV3PostsPath } from 'lib/urls'

export const FETCH_POSTS_KEY = 'FETCH_POSTS'
export const fetchPosts = async () => {
  const response = await fetch(`${apiV3PostsPath}?exclude_body=true`, {
    method: 'GET',
  })

  const postsRaw = (await response.json()).posts
  const posts: { [slug: string]: Post } = {}

  postsRaw.forEach((post: Post) => {
    posts[post.slug] = post
  })

  return posts
}
